import React from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../components/layouts/Layout';
import SEO from '../components/seo';
import Entries from '../components/enter/entries';
import { LoginInner } from './login';
import ContentLoading from '../components/widgets/content_loading';

export const Entry = ({ entry, user, notification, actions }) => {
    const { loggedIn } = user;

    if (!loggedIn) {
        return (
            <Layout user={user} notification={notification} actions={actions}>
                <SEO title="My Entries" />
                <div className="content-container enter">
                    <div className="row">
                        <div className="col-md-10 col-md-offset-1">
                            <ContentLoading
                                hasIcon={false}
                                loadedAction="getPlayerData"
                            >
                                <LoginInner user={user} actions={actions} />
                            </ContentLoading>
                        </div>
                    </div>
                </div>
            </Layout>
        );
    } else {
        return (
            <Layout user={user} notification={notification} actions={actions}>
                <SEO title="My Entries" />
                <div className="content-container enter">
                    <h1 className="text-center">MY ENTRIES</h1>

                    <ContentLoading hasIcon={true} loadedAction="getPlayerData">
                        <Entries entry={entry} actions={actions} />
                    </ContentLoading>
                </div>
            </Layout>
        );
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Entry);
